module.exports = __webpack_public_path__ + "static/media/igor-camargo-alves.9591070e.png";